// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"cd4ac36d","821":"6bc7a3c5","2400":"5d55a844","2671":"5d55a844","3554":"18b4b660","4050":"09a313d4","4497":"cda56a5e","8294":"5d55a844"}[chunkId] + ".chunk.css";
};